export { createEsgSummaryRows, createEsgExternalRows } from "./create-rows";

export const fillInEmailTemplate = ({
  password,
  link,
  orgName,
  supplierName,
  date,
  template,
  firstName,
}) => {
  let emailText = template;
  const replacementArr = [
    [password, "<password>"],
    [link, "<link>"],
    [orgName, "<orgName>"],
    [supplierName, "<supplierName>"],
    [date, "<date>"],
    [firstName, "<firstName>"],
  ];
  replacementArr
    .filter((item) => item[0] !== undefined)
    .forEach((item) => (emailText = emailText.replaceAll(item[1], item[0])));

  return emailText;
};


export const checkQuestionIsSelect = (question) => {
  return !question.type || question.type === "select";
}
